// extracted by mini-css-extract-plugin
export default {"container":"title_container__1najB","inner":"title_inner__1_I5c","isContainer":"title_isContainer__3dQxG","title":"title_title__LtAn6"};